import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=0c6dca3a&"
import script from "./barChart.vue?vue&type=script&lang=js&"
export * from "./barChart.vue?vue&type=script&lang=js&"
import style0 from "./barChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports